<template>
  <div class="bg-purple">
    <div class="stars">
      <div class="central-body">
        <span class="code">404</span>
        <span class="message">Ops! A página não foi encontrada.</span>
        <a href="#" class="btn-go-home" v-on:click="goToDashboard()" title="Ir para a home">
          Ir para a home
          <img class="" src="/static/resources/images/rocket.svg" width="25px">
        </a>
      </div>
      <div class="objects">
        <img class="object_rocket" src="/static/resources/images/rocket.svg" width="40px">
        <div class="earth-moon">
          <img class="object_earth" src="/static/resources/images/earth.svg" width="100px">
          <img class="object_moon" src="/static/resources/images/moon.svg" width="80px">
        </div>
        <div class="box_astronaut">
          <img class="object_astronaut" src="/static/resources/images/astronaut.svg" width="140px">
        </div>
      </div>
      <div class="glowing_stars">
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-not-found',
  methods: {
    goToDashboard() {
      this.$router.push({ name: 'dashboard>budgets' });
    },
  },
};
</script>
<style scoped>
  @-moz-keyframes rocket-movement { 100% {-moz-transform: translate(1200px,-600px);} }
  @-webkit-keyframes rocket-movement {100% {-webkit-transform: translate(1200px,-600px); } }
  @keyframes rocket-movement {
    100% {
      transform: translate(1200px,-600px);
    }
  }
  @-moz-keyframes spin-earth {
    100% {
      -moz-transform: rotate(-360deg); transition: transform 20s;
    }
  }
  @-webkit-keyframes spin-earth {
    100% {
      -webkit-transform: rotate(-360deg); transition: transform 20s;
    }
  }
  @keyframes spin-earth{
    100% {
      -webkit-transform: rotate(-360deg); transform:rotate(-360deg); transition: transform 20s;
    }
  }

  @-moz-keyframes move-astronaut {
    100% { -moz-transform: translate(-160px, -160px);}
  }
  @-webkit-keyframes move-astronaut {
    100% { -webkit-transform: translate(-160px, -160px);}
  }
  @keyframes move-astronaut{
    100% { -webkit-transform: translate(-160px, -160px); transform:translate(-160px, -160px); }
  }
  @-moz-keyframes rotate-astronaut {
    100% { -moz-transform: rotate(-720deg);}
  }
  @-webkit-keyframes rotate-astronaut {
    100% { -webkit-transform: rotate(-720deg);}
  }
  @keyframes rotate-astronaut{
    100% { -webkit-transform: rotate(-720deg); transform:rotate(-720deg); }
  }

  @-moz-keyframes glow-star {
    40% { -moz-opacity: 0.3;}
    90%,100% { -moz-opacity: 1; -moz-transform: scale(1.2);}
  }
  @-webkit-keyframes glow-star {
    40% { -webkit-opacity: 0.3;}
    90%,100% { -webkit-opacity: 1; -webkit-transform: scale(1.2);}
  }
  @keyframes glow-star{
    40% { -webkit-opacity: 0.3; opacity: 0.3;  }
    90%,
    100% {
      -webkit-opacity: 1; opacity: 1;
      -webkit-transform: scale(1.2); transform: scale(1.2); border-radius: 999999px;
    }
  }

  .bg-purple{
    background-color: #3c4c7c;
    background-repeat: repeat-x;
    background-size: cover;
    background-position: left top;
    overflow: hidden;
    height:100vh;
    width: 100%;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
  }

  li {
    float: left;
    padding: 0px 15px;
  }

  li a {
    display: block;
    color: white;
    text-align: center;
    text-decoration: none;
    letter-spacing : 2px;
    font-size: 12px;

    -webkit-transition: all 0.3s ease-in;
    -moz-transition: all 0.3s ease-in;
    -ms-transition: all 0.3s ease-in;
    -o-transition: all 0.3s ease-in;
    transition: all 0.3s ease-in;
  }

  li a:hover {
    color: #ffcb39;
  }

  .btn-go-home{
    position: relative;
    z-index: 200;
    width: auto;
    padding: 10px 15px;
    border-radius: 100px;
    font-weight: 400;
    display: block;
    background: #3c4c7c;
    border-bottom: 5px solid #3c4c7c;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 3px;
    font-size: 21px;
    margin: 40px auto 5px;
    cursor: pointer;
    color: #fff;
    text-decoration: none;
    max-width: 275px;
    -webkit-transition: all 0.3s ease-in;
    -moz-transition: all 0.3s ease-in;
    -ms-transition: all 0.3s ease-in;
    -o-transition: all 0.3s ease-in;
    transition: all 0.3s ease-in;
  }

  .btn-go-home:hover{
    -webkit-box-shadow: 1px 1px 18px 4px rgba(0,0,0,0.3);
    box-shadow: 1px 1px 18px 4px rgba(0,0,0,0.3);
    background: #35436e;
    border-bottom: 5px solid #2a3557;
    color: #fff;
  }

  .central-body{
    padding: 17% 5% 10% 5%;
    text-align: center;
    color: #fff;
    font-size: 1.5em;
    display: block;
  }

  .central-body .code {
    font-size: 10vw;
    display: block;
    line-height: 150px;
  }

  .objects img{
    z-index: 90;
    pointer-events: none;
  }

  .object_rocket{
    z-index: 95;
    position: absolute;
    transform: translateX(-50px);
    top: 75%;
    pointer-events: none;
    animation: rocket-movement 200s linear infinite both running;
  }

  .object_earth{
    position: absolute;
    top: 20%;
    left: 15%;
    z-index: 90;
    animation: spin-earth 100s infinite linear both;
  }

  .object_moon{
    position: absolute;
    top: 12%;
    left: 25%;
    transform: rotate(0deg);
    transition: transform ease-in 99999999999s;
  }

  .object_astronaut{
    animation: rotate-astronaut 200s infinite linear both alternate;
  }

  .box_astronaut{
    z-index: 110 !important;
    position: absolute;
    top: 60%;
    right: 20%;
    will-change: transform;
    animation: move-astronaut 50s infinite linear both alternate;
  }

  .stars{
    background: url(/static/resources/images/overlay_stars.svg);
    background-repeat: repeat;
    background-size: contain;
    background-position: left top;
  }

  .glowing_stars .star{
    position: absolute;
    border-radius: 100%;
    background-color: #fff;
    width: 3px;
    height: 3px;
    opacity: 0.3;
    will-change: opacity;
  }

  .glowing_stars .star:nth-child(1){
    top: 80%;
    left: 25%;
    animation: glow-star 2s infinite ease-in-out alternate 1s;
  }
  .glowing_stars .star:nth-child(2){
    top: 20%;
    left: 40%;
    animation: glow-star 2s infinite ease-in-out alternate 3s;
  }
  .glowing_stars .star:nth-child(3){
    top: 25%;
    left: 25%;
    animation: glow-star 2s infinite ease-in-out alternate 5s;
  }
  .glowing_stars .star:nth-child(4){
    top: 75%;
    left: 80%;
    animation: glow-star 2s infinite ease-in-out alternate 7s;
  }
  .glowing_stars .star:nth-child(5){
    top: 90%;
    left: 50%;
    animation: glow-star 2s infinite ease-in-out alternate 9s;
  }
</style>



// WEBPACK FOOTER //
// src/components/Statics/404.vue